import React from "react";
import CustomeButton from "../../../../components/Button/index";
import EmptyDataView from "../../../../components/nodataview";
import usersIcon from "../../../../assets/images/users-icons.png";
import AccessDropDown from "../../../../components/AccessDropDown";
import useLspPortfolio from "../../actions/useLspPortfolio";
import DeleteModal from "../../../UserAccess/components/DeleteModal";
import AccessList from "../../../../components/lsp/customeraccess/AccessList";
import Notification from "../../../../components/entities/notification/Notification";

const CustomerPortfolio = () => {
  const {
    entityservices,
    entityLists,
    refPanel,
    handleCloseMenu,
    handleSetMenu,
    handleSelection,
    selectedServices,
    searchEntity,
    handlSelectedService,
    accessList,
    paginationOnchange,
    accesspaginationFirst,
    accesspaginationRows,
    openDeleteModal,
    isDeleteAccesModal,
    closeDeleteModal,
    deleteEntity,
    deleteUserAccess,

    hanleChangeUpdateAccess,
    handleSaveUpdateAccess,
    updatEntity,
    handleDiscardUpdate,
    updateBtnAvailbel,

    accessmsg,
    removeMsg,
    updateMsgState,
  } = useLspPortfolio();

  return (
    <>
      <div className="formgrid grid">
        <div className="field col-12 md:col-12 sm:col-12">
          <div className="flex flex-wrap justify-content-between align-items-center mb-2">
            <div className="left-content">
              <p className="general-info">Customer Portfolio</p>
              <p className="profile-para">
                Add the cutomers this partner operates with and select the
                services they provide.
              </p>
            </div>
            <div className="right-content mt-3 md:mt-0 flex ml-3">
              <CustomeButton
                label="Manage Access"
                icon="pi pi-angle-down"
                variant="contained"
                iconPos="right"
                onClick={(e) => handleSetMenu(e)}
              />
            </div>
          </div>
        </div>

        <Notification
          message={removeMsg}
          setMessage={updateMsgState}
          successMessage={accessmsg}
          setSuccessMessage={updateMsgState}
        />

        {accessList?.length > 0 ? (
          <div className="field col-12 mb-2 mt-3">
            <AccessList
              allservices={entityservices}
              accesslists={accessList}
              openDeleteModal={openDeleteModal}
              paginationOnchange={paginationOnchange}
              paginationFisrt={accesspaginationFirst}
              paginationRows={accesspaginationRows}
              hanleChangeUpdateAccess={hanleChangeUpdateAccess}
              updatEntity={updatEntity}
            />

            {updateBtnAvailbel && (
              <div className="col-12 drop-section-3 p-0">
                <div className="flex justify-content-end mt-3">
                  <CustomeButton
                    label="Discard"
                    variant="outlined"
                    className="mr-2"
                    onClick={handleDiscardUpdate}
                  />
                  <CustomeButton
                    label="Save Changes"
                    variant="contained"
                    className="access-btn"
                    onClick={handleSaveUpdateAccess}
                    // loading={isLoading}
                    disabled={!selectedServices.length > 0}
                  />
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className="field col-12 mb-2 mt-3">
            <EmptyDataView
              Icon={
                <img
                  className="users-card-icon-img"
                  src={usersIcon}
                  alt="Users Icon"
                />
              }
              Header={"No Customers Assigned"}
              Description={
                <>
                  Let's build a list of all customers involved with this
                  partner.
                  <br />
                  Let's get started!
                </>
              }
            />
          </div>
        )}
        <AccessDropDown
          refPanel={refPanel}
          data={entityLists}
          entityservices={entityservices}
          handleSelection={handleSelection}
          selectedServices={selectedServices}
          handleClose={handleCloseMenu}
          searchEntity={searchEntity}
          handlSelectedService={handlSelectedService}
        />

        {isDeleteAccesModal && (
          <DeleteModal
            visible={isDeleteAccesModal}
            selectedEntity={deleteEntity}
            closeModal={closeDeleteModal}
            deleteUserAccess={deleteUserAccess}
          />
        )}
      </div>
    </>
  );
};

export default CustomerPortfolio;
